import React from "react";
import Rive from "@rive-app/react-canvas-lite";

export const beastStyles = ["grok", "grogg"] as const;
type BeastStyle = typeof beastStyles[number];
// This could eventually live in AssetUtils or something similar.
const getRiveAnimationProps = (beastStyle: BeastStyle) => {
	switch (beastStyle) {
		case "grok":
			return {
				animationFileName: "BA_CharacterExperimentsGrok_v2",
				stateMachineName: "State Machine 1",
			};
		case "grogg":
			return {
				animationFileName: "BA_CharacterExperimentsGrogg_v1",
				stateMachineName: "Eye Move Machine", // File also includes "Grogg Wave Machine"
			};
		default:
			const exhaustiveCheck: never = beastStyle;
			throw new Error(`Unhandled beast style case: ${exhaustiveCheck}`);
	}
};

const getRiveAnimationFile = function(fileName: string) {
	return global.BASE_URL + "assets/animations/rive/" + fileName + ".riv";
};

export const AnimatedCharacter = ({
	beastStyle,
	className,
}: {
	beastStyle: BeastStyle;
	className: string;
}) => {
	const {animationFileName, stateMachineName} = getRiveAnimationProps(
		beastStyle
	);
	return (
		<Rive
			className={className}
			src={getRiveAnimationFile(animationFileName)}
			stateMachines={stateMachineName}
		/>
	);
};
